import React from 'react'
import PropTypes from 'prop-types'
import { Carousel } from 'pcln-carousel'
import { DepartureSummary } from './DepartureSummary'

const DepartureSummaryCarousel = ({
  selectedSlices,
  searchSlices,
  currentSlide = 0,
  isMultiDestination = false,
  onSlideChange = () => {},
}) => {
  const Wrapper = selectedSlices.length === 1 ? React.Fragment : Carousel
  return (
    <Wrapper
      stretchSlideHeight={false}
      visibleSlides={[1, 1, 1]}
      mobileVisibleSlides={[1.1, 1.1, 1.1, 1.1]}
      currentSlide={currentSlide}
      slideSpacing={1}
      onSlideChange={onSlideChange}
    >
      {selectedSlices.map((slice, index) => (
        <DepartureSummary
          key={`slice${index}`}
          {...slice}
          isMultiDestination={isMultiDestination}
          cityInfo={searchSlices?.[index]}
        />
      ))}
    </Wrapper>
  )
}

DepartureSummaryCarousel.propTypes = {
  selectedSlices: PropTypes.arrayOf({
    /** Number of stops in slice */
    stopsText: PropTypes.string.isRequired,

    /** Duration of slice */
    durationText: PropTypes.string.isRequired,

    /** Callback invoked when user wants to return to Departure Tab */
    changeFlightHandler: PropTypes.func.isRequired,

    /** React node returned from `SliceDetails` component */
    sliceDetailsNode: PropTypes.node.isRequired,

    /** Boolean to show/hide overnight icon */
    isOvernight: PropTypes.bool,

    /** Price object with dollars and cents */
    price: PropTypes.shape({
      dollar: PropTypes.string,
      cents: PropTypes.string,
    }).isRequired,

    className: PropTypes.string,

    /** Designates position: sticky */
    isSticky: PropTypes.bool,

    /** Change vs Change Flight Text */
    isChangeFlightLinkVariant: PropTypes.bool,

    /** The % of page scrolled */
    scrollPosition: PropTypes.number,
  }),
  /** current slice index */
  currentSlide: PropTypes.number,

  /** is multidestination */
  isMultiDestination: PropTypes.bool,

  /** get all the cities for MD eg: NYC-LAX  */
  searchSlices: PropTypes.array,

  /** Change handler for when slices change */
  onSlideChange: PropTypes.func,
}

export { DepartureSummaryCarousel }
